<div class="FeatureInfoTool">

    <LocationInput style="display:none;" v-model="coords" :map="map" :alwaysEnabled="true" cursor="" :showMarker="show" markerUrl="tivigi/img/map_query.png" />

    <MapQueryTool :coords="coords" :map="map" :result.sync="resultset" :queryRadius="queryRadius" />

    <div v-if="coords == null">
        <strong>Kein Ort ausgewählt.</strong>
    </div>

    <div v-else-if="resultset.numFeatures() == 0">
        <strong>Über den gewählten Ort sind keine Informationen verfügbar.</strong>
    </div>

    <CollapsibleFeaturesList v-else :featuresList="resultset" />


</div>